import InventarioModel from "../models/inventarioModel";
import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";

export default class InventarioService extends IService<InventarioModel> {
    constructor() {
        super("Inventario");
    }

    public insertInventario(model: InventarioModel): Promise<Response> {
        return nfetch(`/${this.controllerName}/InsertInventario`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify(model),
        });
    }

    public insertAjusteLote(model: InventarioModel, produtoLoteId: number, quantidade: number): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/InsertAjusteLote?produtoLoteId=${produtoLoteId}&quantidade=${quantidade}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
                },
                body: JSON.stringify(model),
            },
        );
    }

    public finalizarInventario(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/FinalizarInventario?inventarioId=${id}`, {
            method: "post",
            credentials: "same-origin",
        });
    }

    public cancelarInventario(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/CancelaInventario?inventarioId=${id}`, {
            method: "post",
            credentials: "same-origin",
        });
    }

    public getFinalizado(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFinalizado?inventarioId=${id}`, {
            credentials: "same-origin",
        });
    }

    public getLotesInventario(
        ignorarLotesZerados = false,
        estoqueId: number,
        grupoProdutoId: number,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetLotesInventario?estoqueId=${estoqueId}&ignorarLotesZerados=${ignorarLotesZerados}&grupoProdutoId=${grupoProdutoId}`,
            {
                credentials: "same-origin",
            },
        );
    }
}
